import AppRouter from "./routes";
import { ThemeProvider } from "@flash-tecnologia/hros-web-ui-v2";
import { trpc, trpcClient, queryClient } from "./api/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { FlagsProvider } from "@flash-tecnologia/feature-flags";
import { useSession } from "./hooks";
import "../src/i18n";

export default function Root() {
  const { companyId, economicGroupId, userId } = useSession();

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <FlagsProvider
        appName="hros-web-setup"
        url={process.env.UNLEASH_PROXY_URL || ""}
        token={process.env.UNLEASH_PROXY_KEY || ""}
        refreshIntervalSeconds={1800}
        initialContext={{
          userId,
          properties: {
            economicGroupId,
            companyId,
            employeeId: userId,
          },
        }}
      >
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <AppRouter />
          </ThemeProvider>
        </QueryClientProvider>
      </FlagsProvider>
    </trpc.Provider>
  );
}
